<template>
  <Button :text="text" class="btn--primary" @click-button="onClick" />
</template>

<script>
import Button from '../../atoms/buttons/Button'
export default {
  components: { Button },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--primary {
  background-color: $primary;
  color: $white;

  a {
    color: $white;
  }
}
</style>
